import type { Campaign } from 'c-sdk';

const campaignName = (campaign: Campaign) =>
    `${campaign?.name} - #${campaign?.id} ${campaign?.reference}`;

export default campaignName;
